import React from 'react';
import PropTypes from 'prop-types';
import * as Icon from 'react-bootstrap-icons';

import styles from './ProgressSteps.module.css';

export const ProgressSteps = ({ status, steps = [] }) => {
  // Esperamos 5 elementos (steps): punto, línea, punto, línea, punto
  // Esperamos 6 elementos (data): icono, texto, icono, texto, icono, texto
  return (
    <>
    {(status !== null) &&
    <div className="row mb-3">
        <div className={"col " + styles.dataContainerL}>
            <div className={styles.dataContainer}>
                <div className='me-2'>
                  {(status === 0)
                  ? <Icon.X color={ (parseInt(status) > 0) ? '#7FAE1B' : '#6C757D' } size={28} />
                  : <Icon.Check color={ (parseInt(status) > 0) ? '#7FAE1B' : '#6C757D' } size={28} />
                  }
                </div>
                <div style={{color: (parseInt(status) > 0) ? '#000000' : '#6C757D'}}>
                    <div className={styles.resumenText}>Invitación</div>
                    <div className={styles.resumenText}>{(status > 0) ? 'enviada' : 'no enviada'}</div>
                </div>
            </div>
        </div>
        <div className={"col " + styles.dataContainerC}>
            <div className={styles.dataContainer}>
                <div className='me-2'><Icon.Clock color={(parseInt(status) === 0) ? '#6C757D' : (parseInt(status) === 1) ? '#FEC600' : '#7FAE1B'} size={18} /></div>
                <div style={{color: (parseInt(status) > 0) ? '#000000' : '#6C757D'}}>
                    <div className={styles.resumenText}>Pendiente</div>
                    <div className={styles.resumenText}>de aceptar</div>
                </div>
            </div>
        </div>
        <div className={"col " + styles.dataContainerR}>
            <div className={styles.dataContainer}>
                <div className='me-2'>
                  {(status === 2)
                  ? <Icon.X color={(parseInt(status) <= 1) ? '#6C757D' : (parseInt(status) === 3) ? '#7FAE1B' : '#F34336'} size={28} />
                  : <Icon.Check color={(parseInt(status) <= 1) ? '#6C757D' : (parseInt(status) === 3) ? '#7FAE1B' : '#F34336'} size={28} />
                  }
                </div>
                <div style={{color: (parseInt(status) > 1) ? '#000000' : '#6C757D'}}>
                    <div className={styles.resumenText}>{(status === 3) ? 'Enlazado(a)' : 'No enlazado(a)'}</div>
                    <div className={styles.resumenText}>al app</div>
                </div>
            </div>
        </div>
    </div>
    }
    <div className={styles.container}>
      {[0, 2, 4].map((i, idx) => (
        <React.Fragment key={`step-${i}`}>
          <div
            className={styles.circle}
            style={{
              backgroundColor: steps[i]?.color || '#ccc',
            }}
          />
          {i < 4 && (
            <div
                className={styles.line}
              style={{
                backgroundColor: steps[i + 1]?.color || '#ccc',
              }}
            />
          )}
        </React.Fragment>
      ))}
    </div>
    </>
  );
};

ProgressSteps.propTypes = {
    status: PropTypes.number.isRequired,
}